(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our-story-editorial"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=document.querySelector('.bw-ed--story');
    if(!root){return;}
    var els=root.querySelectorAll('[data-reveal]');
    if(!els.length||typeof IntersectionObserver==='undefined'){return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){entry.target.classList.add('in');io.unobserve(entry.target);}
      });
    },{threshold:.16,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-page"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var els=document.querySelectorAll('.bw-story [data-reveal]');
    if(!els.length||typeof IntersectionObserver==='undefined'){return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){entry.target.classList.add('in');io.unobserve(entry.target);}
      });
    },{threshold:.18,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sustainability-page"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=document.querySelector('.bw-ed--sus');
    if(!root){return;}
    var els=root.querySelectorAll('[data-reveal]');
    if(!els.length||typeof IntersectionObserver==='undefined'){return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){entry.target.classList.add('in');io.unobserve(entry.target);}
      });
    },{threshold:.16,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el);});
  })();

  } catch(e) { console.error(e); }
})();
})();
